'use client';

import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../../headers/page';
import { WardrobeBagButton } from '@/components/buttons/wardrobe-bag-button';

export const WardrobeHeader: FC = () => {
  const [t] = useTranslation();

  return (
    <div className="flex items-start w-full justify-between gap-4 mt-6">
      <PageHeader
        title={t('page.wardrobe.title')}
        descriptionText={t('page.wardrobe.description')}
      />

      <div className="inline-flex items-center pt-2">
        <WardrobeBagButton />
      </div>
    </div>
  );
};
